export default {
  customer: 'VF_SN_DEV',
  customerLogo: 'logos/lyse-logo.png',
  logoStyle:{
    marginTop: '-5px',
    marginRight: '10px',
    maxWidth: '170px',
    maxHeight: '44px'
  },
  agTitleFirst: 'Bygge',
  agTitleSecond: 'spesifiksjoner',
  agTitleThird: '',
  DocumentsDisabled: true,
  DocumentRequirementsDisabled: true
}



/** WEBPACK FOOTER **
 ** app/config.js
 **/